export const errorStatusMsgVI = {
    401: "Tên đăng nhập đã tồn tại",
    402: "Tạo tài khoản thất bại",
    403: "Body thiếu key",
    404: "Tên đăng nhập không tồn tại",
    405: "Mật khẩu sai",
    406: "Lỗi khi tạo access token",
    407: "Lỗi khi tạo refresh token",
    408: "Không tìm thấy access token",
    409: "Không tìm thấy refresh token",
    410: "Access token không hợp lệ",
    411: "Refresh token không hợp lệ",
    412: "Không tìm thấy người dùng",
    413: "Access token hết hạn",
    414: "Refresh token hết hạn",
    415: "Lỗi khi cập nhật thông tin người dùng",
    416: "Lỗi khi cập nhật mật khẩu",
    417: "Lỗi khi cập nhật điểm người dùng",
    418: "Lỗi khi gửi mail",
    419: "Không tìm thấy gmail",
    420: "Lỗi khi đặt lại mật khẩu",
    421: "Tài khoản gmail đã được sử dụng",
    422: "Lỗi khi lấy danh sách xếp hạng",
    423: "Tên này đã được sử dụng",
    424: "Param thiếu key",
    425: "Lỗi khi lấy mail token"
}